export default __webpack_public_path__ + "static/media/dermaheal6.ce64433f.jpg";